module.exports = __webpack_public_path__ + "static/media/44.7f977de4.png";